import Vue from 'vue';
import App from './App.vue';
import router from './router';
import ElementUI from 'element-ui';
import VueI18n from 'vue-i18n';
import {
    messages
} from './components/common/i18n';
import 'element-ui/lib/theme-chalk/index.css'; // 默认主题
// import './assets/css/theme-green/index.css'; // 浅绿色主题
import './assets/css/icon.css';
import '../public/index.css'
import './components/common/directives';
import 'babel-polyfill';
import { dateFormat } from '@/utils/helper';
import store from './store/index'
import { API } from '../public/config'
// import echarts from 'echarts';
// Vue.prototype.$echarts = echarts;
import { RefreshToken } from './api/Auth'
import { Loading } from 'element-ui';
// 配置MintUI
import iconPicker from 'vue-fontawesome-elementui-icon-picker';
import VideoPlayer from 'vue-video-player'
require('../node_modules/video.js/dist/video-js.css')
require('vue-video-player/src/custom-theme.css')
Vue.use(VideoPlayer)
const hls = require("videojs-contrib-hls")
Vue.use(hls)
    //全局过滤器
Vue.filter('formateData', function(time) {
    let date = new Date(time);
    return dateFormat.formatDate(date, 'yyyy-MM-dd hh:mm');
})

Vue.config.productionTip = false;
Vue.use(VueI18n);
Vue.use(ElementUI, { size: 'small' });
const i18n = new VueI18n({ locale: 'zh', messages });
Vue.use(iconPicker);
//使用钩子函数对路由进行权限跳转
router.beforeEach((to, from, next) => {
    var kCount = Object.keys(to.meta).length > 0;
    // document.title = `${kCount?to.meta.title:"登录"} | vue-manage-system`;
    document.title = `${kCount?to.meta.title:"登录"} `;
    const role = localStorage.getItem('ms_username');
    if (!role && to.path !== '/Login') {
        // if (to.path == "/ScaleIndex" || to.path == "/BasicInfo" || to.path == "/Login") {
        //if (to.path == "/ScaleIndex" || to.path == "/BasicInfo" || to.path == "/Login") {
        //     next();
        //} else {
        next('/Login');
        //}
    } else if (to.meta.permission) {
        // 如果是管理员权限则可进入，这里只是简单的模拟管理员权限而已
        role === 'admin' ? next() : next('/403');
    } else {
        // 简单的判断IE10及以下不进入富文本编辑器，该组件不兼容
        if (navigator.userAgent.indexOf('MSIE') > -1 && to.path === '/editor') {
            Vue.prototype.$alert('vue-quill-editor组件不兼容IE10及以下浏览器，请使用更高版本的浏览器查看', '浏览器不兼容通知', {
                confirmButtonText: '确定'
            });
        } else {
            next();
        }
    }
});

// 配置axios
import Axios from 'axios'

// 配置公共URL
//Axios.defaults.baseURL = 'http://192.168.78.86:8085/api/v1/';
let baseUrl = ''
if (process.env.NODE_ENV == 'development') {
    // 开发环境的url
    baseUrl = API.DEV_SERVER + "/api/v1/"
} else if (process.env.NODE_ENV == 'production') {
    // 正式环境的 request url
    // baseUrl = API.PRO_SERVER
    baseUrl = 'http://' + window.location.host + "/api/v1/";
}
localStorage.setItem('serverUrl', baseUrl);
Axios.defaults.baseURL = baseUrl
Vue.prototype.GlobalConfig = { baseUrl: baseUrl };

let loadingInstance;
// 配置请求拦截器，显示loading图标  
Axios.interceptors.request.use(function(config) {
    if (!config.url.includes("GetIndexData") && !config.url.includes("GetScaleGroupData") &&!config.url.includes("GetRunningStatus") &&!config.url.includes("GetDevData")) {
        loadingInstance = Loading.service({
            lock: true,
            text: '玩命加载中......',
            background: 'rgba(0,0,0,0.5)'
        })
    }

    // const token = localStorage.getItem('token');
    // if (token) {
    //     config.headers.Authorization = 'Bearer ' + token
    // }
    return config;
});

// 配置响应拦截器，关闭loading图标
// Axios.interceptors.response.use(function (response) {
//     //this.$nextTick(() => { // 以服务的方式调用的 Loading 需要异步关闭
//     loadingInstance.close();
//     // });
//     return response;
// });

// 拦截响应
Axios.interceptors.response.use(
    async response => {
        loadingInstance.close();
        // if (response.data.code == 9001) {
        //     localStorage.setItem('token', response.data.token);
        // }
        // response.data = response.data.data;
        //data.success = data.code === 1
        return response;
        //return data
    },
    async error => {
        loadingInstance.close();

        // const res = {
        //     success: false,
        //     code: 0,
        //     msg: ''
        // }

        // if (error) {
        //     const {
        //         config,
        //         data
        //     } = error.response
        //         // 刷新令牌
        //     const {
        //         status
        //     } = data;

        //     if (status === 401) {
        //         // this.$message.error('登录过期');
        //         router.push('/Login');
        //         // const resRefresh = await RefreshToken();
        //         // if (resRefresh.status === 0) {
        //         //     localStorage.setItem('token', resRefresh.msg);
        //         //     return Axios.request(error.config)
        //         // } else {
        //         //     router.push('/Login');
        //         // }
        //     }

        // }
        // return res
    }
)


Vue.prototype.$zybhttp = Axios

new Vue({
    router,
    i18n,
    store,
    render: h => h(App)
}).$mount('#app');